import { render, staticRenderFns } from "./SpecialOfferMenuComponent.vue?vue&type=template&id=6f30a256&scoped=true"
import script from "./SpecialOfferMenuComponent.vue?vue&type=script&lang=js"
export * from "./SpecialOfferMenuComponent.vue?vue&type=script&lang=js"
import style0 from "./SpecialOfferMenuComponent.vue?vue&type=style&index=0&id=6f30a256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f30a256",
  null
  
)

export default component.exports